import React from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { UserPlus, CalendarPlus, TrendingDown } from 'lucide-react';
import paths from 'routes/paths';
import colors from 'theme/colors';
import breakpoints from 'theme/breakpoints';
import { Section, SectionInner, Eyebrow, SectionTitle, PrimaryButton, campaign } from './shared';

const ASSETS = '/assets/images/promo/3-anos';

const STEPS = [
    {
        icon: UserPlus,
        title: 'Crie sua conta de produtor',
        text: 'Leva menos de 5 minutos. Já tem conta? Bora, é só continuar logado.',
    },
    {
        icon: CalendarPlus,
        title: 'Cadastre seu evento até 30/11',
        text: 'Todo evento criado dentro da campanha já entra na condição especial.',
    },
    {
        icon: TrendingDown,
        title: 'Venda com taxa menor por 3 meses',
        text: '6% no Pix e 8% no cartão nas vendas desse evento. Sem pegadinha.',
    },
];

export default function HowItWorksSection() {
    const navigate = useNavigate();

    return (
        <Section>
            <BgBlob src={`${ASSETS}/blob-1.png`} alt="" aria-hidden="true" />

            <SectionInner>
                <Eyebrow>Como funciona</Eyebrow>
                <SectionTitle>3 passos e já tá dentro</SectionTitle>

                <StepsGrid>
                    {STEPS.map(({ icon: StepIcon, title, text }, i) => (
                        <StepCard key={i}>
                            <StepNumber>{i + 1}</StepNumber>
                            <StepIconBox>
                                <StepIcon size={20} color={campaign.purple} />
                            </StepIconBox>
                            <StepTitle>{title}</StepTitle>
                            <StepText>{text}</StepText>
                        </StepCard>
                    ))}
                </StepsGrid>

                <CtaWrap>
                    <Mascot src={`${ASSETS}/gato-chapeu.png`} alt="" aria-hidden="true" />
                    <PrimaryButton
                        onClick={() => navigate(paths.partner.createAccount)}
                    >
                        Bora começar
                    </PrimaryButton>
                </CtaWrap>
            </SectionInner>
        </Section>
    );
}

const StepsGrid = styled.div`
    display: grid;
    grid-template-columns: 1fr;
    gap: 20px;
    margin-top: 36px;

    @media screen and (min-width: ${breakpoints.smd}) {
        grid-template-columns: repeat(3, 1fr);
    }
`;

const StepCard = styled.div`
    position: relative;
    background: #fff;
    border: 1px solid ${colors.night}14;
    border-radius: 18px;
    padding: 28px 22px 22px;
`;

const StepNumber = styled.div`
    position: absolute;
    top: -14px;
    left: 22px;
    width: 28px;
    height: 28px;
    border-radius: 50%;
    background: ${campaign.magenta};
    color: #fff;
    font-size: 13px;
    font-weight: 800;
    display: flex;
    align-items: center;
    justify-content: center;
`;

const StepIconBox = styled.div`
    width: 44px;
    height: 44px;
    border-radius: 12px;
    background: ${campaign.purple}14;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 14px;
`;

const StepTitle = styled.h3`
    font-size: 16.5px;
    font-weight: 700;
    color: ${colors.nightDark};
    margin: 0 0 8px;
`;

const StepText = styled.p`
    font-size: 14.5px;
    line-height: 1.5;
    color: ${colors.night};
    margin: 0;
`;

const CtaWrap = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 16px;
    margin-top: 40px;
`;

const Mascot = styled.img`
    width: 52px;
    display: none;

    @media screen and (min-width: ${breakpoints.smd}) {
        display: block;
    }
`;

const BgBlob = styled.img`
    position: absolute;
    left: -60px;
    bottom: -40px;
    width: 220px;
    opacity: 0.12;
    pointer-events: none;
    user-select: none;
`;
